export default {
    props: {
        values: {
            type: Array,
            kComposite: 'values'
        }, 
        axis: {
            type: String,
            kComposite: 'axis'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotMeasure/Measures.js